import { useState, useEffect } from "react";
import { Modal, message } from "antd";
import Api from "../../shared/Api";
import { ApiEndpoints } from "../../shared/Common";
import CreateOrEditPrivateTraining from "../createOrEditPrivateTraining/CreateOrEditPrivateTraining";
import { Spin } from "antd-v5";
import { useTranslation } from "react-i18next";
import { IEqUiSelectModel, IGetPopulation } from "../../shared/interfaces/ILocationDto";
import React from "react";
import { EqEntityTrainerStudent } from "../../shared/interfaces/IUserInfoDto";
import { EqUiStudentGroup } from "../../shared/interfaces/IUserGroupDto";
import { GetSchoolStudentsDto } from "../../shared/interfaces/schoolTraining/school";
import { IStudentHorseList } from "../../shared/interfaces/horse/IHorses";


const PrivateTrainingModal = ({ 
  trainingId, visible, onClose,
  // areas,
  // weekDays,
  // studentHorsesList,
  // trainerStudents,
  // population,
  // groupPopulation

}:any) => {
  const [loading, setLoading] = useState(true);
  const [selectedTraining, setSelectedTraining] = useState(null);
    const [areas, setAreas] = React.useState<IEqUiSelectModel[]>([]);
    const [weekDays, setWeekDays] = React.useState<IEqUiSelectModel[]>([]);
    const [studentHorsesList, setStudentHorsesList] = React.useState<IStudentHorseList[]>([]);
    const [trainerStudents, setTrainerStudents] = React.useState<EqUiStudentGroup[]>([]);
    const [population, setPopulation] = useState<IGetPopulation[]>([]);
    const [groupPopulation, setGroupPopulation] = React.useState<IGetPopulation[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (trainingId && visible) {
      fetchAllData();
    }
  }, [trainingId, visible]);

  const fetchAllData = async () => {
    setLoading(true);
    try {
      
      const [
        trainingResponse,
        trainerStudentsResponse,
        populationResponse,
        groupPopulationResponse,
        areasResponse,
        weekDaysResponse
      ] = await Promise.all([
        Api.get(`${ApiEndpoints.TrainerTraining.GetTrainerTrainingsById}/${trainingId}`),
        Api.get(ApiEndpoints.TrainerStudents.GetTrainerStudentsGroupDto),
        Api.get(ApiEndpoints.eventGetPopulation),
        Api.get(ApiEndpoints.eventGetGroupPopulation),
        Api.get(ApiEndpoints.Location.GetUserAreaOptions),
        Api.get(ApiEndpoints.eventGetWeekDays),
      ]);

      // Process trainer students & horses list
      let trainerStudentsData = trainerStudentsResponse.data;
      const studentHorsesListOptions = trainerStudentsData.map((item: any) => {
        const horseListObj = [
          ...item.user.horses.map((h: any) => ({
            key: h.id,
            value: h.name,
            label: h.name
          })),
          ...item.trainer.horses.map((h: any) => ({
            key: h.id,
            value: h.name,
            label: h.name
          }))
        ];
        return { key: item.key, horseList: horseListObj };
      });

      // Set state
      setSelectedTraining(trainingResponse.data);
      setTrainerStudents(trainerStudentsData);
      setStudentHorsesList(studentHorsesListOptions);
      setPopulation(populationResponse.data);
      setGroupPopulation(groupPopulationResponse.data);
      setAreas(areasResponse.data);
      setWeekDays(weekDaysResponse.data);

    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to load training data");
    }
    setLoading(false);
  };

  const handleOnUpdateTraining = (updatedTraining:any) => {
    console.log("Updated Training:", updatedTraining);
    onClose(); // Close modal after update
  };

  return (
    <Modal
      title={t("training")}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={"85vw"}
    >
      {loading ? (
        <Spin style={{width:"-webkit-fill-available"}} />
      ) : (
        <CreateOrEditPrivateTraining
          event={selectedTraining}
          areas={areas}
          weekDays={weekDays}
          population={population}
          groupPopulation={groupPopulation}
          trainerStudents={trainerStudents}
          studentHorsesList={studentHorsesList}
          onCreateOrUpdateActivity={handleOnUpdateTraining}
        />
      )}
    </Modal>
  );
};

export default PrivateTrainingModal;
